<template>
    <div class="planos-container">
    <div class="back-button-top">
      <!-- O botão voltar no passo inicial foi removido pois não há passo anterior -->
    </div>
    <div class="logo-container">
      <img src="@/assets/img/logo.png" alt="LubConsulta" class="logo">
    </div>
    <div class="wizard narrow-wizard">
      <!-- Passo 1 foi removido da visualização inicial -->
      <div class="step" :class="{ 'active': currentStep === 2 }">
        <div class="step-number">1</div>
        <div class="step-info">
          <div class="step-title">Cadastro</div>
          <div class="step-description">Preencha os dados para criar sua conta.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 3 }">
        <div class="step-number">2</div>
        <div class="step-info">
          <div class="step-title">Assinatura</div>
          <div class="step-description">Parabéns, seu cadastro foi realizado com sucesso.</div>
        </div>
      </div>
    </div>
    <div class="step-content narrow-content">
      <!-- O v-if para o passo 1 foi removido, a página começa no passo 2 -->

      <div v-if="currentStep === 2" class="step-2">
        <h2 class="narrow-title">Complete seu Cadastro</h2>
        <p class="subtitle">Preencha o formulário abaixo para se cadastrar no Plano Plus de <strong>DEGUSTAÇÃO</strong>.</p>
        <div class="plan-card2" style="border: 1px solid #f4a954; border-radius: 8px; padding: 10px;">                  
          <div class="plan-sub" style="font-weight: bold; text-align: left;">VOCÊ ESTÁ SE CADASTRANDO NO</div>
          <div class="plan-name" style="background-color: #ef8d1e; color: white; font-size: 24px; font-weight: bold; border-radius: 5px; padding: 8px; width: 250px; margin-bottom: 5px;">
            Plano Plus
          </div>
          <div class="plan-value" style="margin-bottom: 10px; padding: 10px;">
            <p><strong>VALOR</strong></p>
            <div class="plan-price" style="font-weight: bold; font-size: 20px;  color:rgb(133, 131, 131);">
              <strong>GRATUITO 7 DIAS</strong>
            </div>
          </div>

          <!-- Seção de Cupom Removida -->

          <div class="collapse-item" style="margin: 5px 0;">
            <!-- O cabeçalho não é mais clicável, e o conteúdo está sempre visível -->
            <div class="collapse-header">
              <IconArrowBigRightFilled stroke={2} style="display: inline-block; vertical-align: middle; color: #3E8DDD; margin-right: 8px;" />   
              <strong>Ver detalhes do plano</strong>
            </div>
            <!-- O v-if foi removido para que os detalhes sempre apareçam -->
            <div class="collapse-content" style="margin-top: 5px;">
              <div>
                  <p>O que o plano oferece <strong>nestes 7 dias de degustação</strong>:</p>
                  <ul style="margin-left: 20px; margin-top: 10px;">
                      <li>Catálogo completo de lubrificantes e filtros</li>
                      <li>Consulta de produtos pela placa do veículo</li>
                      <li>Consulta de veículos pelo modelo do veículo</li>
                      <li>Download do manual do propietário</li>
                      <li>Ficha técnica de lubrificantes</li>
                      <li>Cadastro de clientes</li>
                      <li>Registro de serviço de troca de óleo</li>
                      <li>Lembrete automático via WhatsApp para a próxima troca de óleo do veículo</li>
                  </ul>
              </div>
            </div>
          </div>

        </div>

        <div class="form-section">
          <h2 class="form-title">Dados do Cliente</h2>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">CNPJ <span class="required">*</span></label>
              <input 
                type="text" 
                class="form-input" 
                v-model="personalInfo.document" 
                placeholder="00.000.000/0000-00"
                @input="onCnpjInput"
                @blur="fetchAndPopulateCustomerData" 
                @keydown.enter.prevent="handleCnpjNavigation"
                @keydown.tab.prevent="handleCnpjNavigation">
            </div>
            <div class="form-group">
              <label class="form-label">Nome completo <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="personalInfo.fullName"
                  :disabled="fieldStates.fullName"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Telefone <span class="required">*</span></label>
              <input
                ref="phoneInput"
                type="text"
                class="form-input"
                :class="{ 'input-invalid': validation.phoneTouched && !personalInfo.phone }"
                v-model="personalInfo.phone"
                placeholder="(99) 9 9999-9999"
                @input="onPhoneInput"
                @blur="validatePhoneField"
              >
            </div>

            <!-- E-mail -->
            <div class="form-group">
              <label class="form-label">E-mail <span class="required">*</span></label>
              <input
                ref="emailInput"
                type="email"
                class="form-input"
                :class="{ 'input-invalid': validation.emailTouched && !personalInfo.email }"
                v-model="personalInfo.email"
                placeholder="seu@email.com"
                @input="checkEmailPattern"
                @blur="triggerContactModal"
              >
            </div>
          </div>
            
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Endereço <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.street"
                :disabled="fieldStates.street"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>

            <div class="form-group">
              <label class="form-label">CEP <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.zipCode"
                :disabled="fieldStates.zipCode"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Número <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.number"
                :disabled="fieldStates.number"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Bairro</label>
              <input type="text" class="form-input" v-model="billingAddress.bairro"
                :disabled="fieldStates.bairro"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Complemento</label>
              <input type="text" class="form-input" v-model="billingAddress.complement"
                :disabled="fieldStates.complement"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">País</label>
              <input type="text" class="form-input" v-model="billingAddress.country"
                :disabled="fieldStates.country"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Brasil"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">UF <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.state"
                :disabled="fieldStates.state"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="UF"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Cidade <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.city"
                :disabled="fieldStates.city"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Preenchimento automático"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>
        </div>

        <!-- Seção de Forma de Pagamento totalmente removida -->

        <div class="navigation-buttons">
          <!-- Botão "Voltar" foi removido pois não há passo anterior -->
          <button class="nav-button btn btn-primary" @click="finalizeRegistration" :disabled="isProcessing">
              {{ isProcessing ? 'Processando...' : 'Finalizar Cadastro' }}
          </button>
        </div>

      </div>
      
      <div v-if="currentStep === 3" class="step-3">
        <center>
        <h2>Cadastro Realizado</h2>
        <p>Seu plano foi registrado com sucesso! Verifique seu e-mail para obter os dados de acesso.</p>
        <br>
        <a href="https://app.lubconsulta.com.br" class="nav-button btn btn-primary">Acessar plataforma</a>
        </center>
      </div>
    </div>

    <footer class="site-footer">
      @ lubconsuta.com.br
    </footer>

    <div class="whatsapp-button" @click="toggleWhatsAppChat">
      <div class="pulse">
        <i class="ti ti-brand-whatsapp"></i>
      </div>
    </div>

    <div v-if="showWhatsAppChat" class="whatsapp-chat">
      <div class="chat-header">
        <h3>Envie sua mensagem</h3>
        <button @click="toggleWhatsAppChat" class="close-chat">
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="chat-body">
        <textarea v-model="whatsappMessage" placeholder="Digite sua mensagem..."></textarea>
      </div>
      <div class="chat-footer">
        <button @click="sendWhatsAppMessage" class="send-button">
          Enviar <i class="ti ti-send"></i>
        </button>
      </div>
    </div>
  </div>

    <div v-if="showModal" class="modal-overlay">
        <div class="modal-content">
            <h3 class="modal-title">{{ modalTitle }}</h3>
            <p class="modal-message">{{ modalMessage }}</p>
            <button class="modal-close-btn" @click="closeModal">Fechar</button>
        </div>
    </div>


    <div v-if="showContactAlertModal" class="modal-overlay">
        <div class="modal-content">
            <h3 class="modal-title">Validação de Dados</h3>
            <p class="modal-message" style="font-size: 16px;">
                Por favor, confirme se seu Telefone: <strong>{{ personalInfo.phone }}</strong> 
                e E-Mail: <strong>{{ personalInfo.email }}</strong> estão corretos antes de prosseguir.
            </p>
            <button class="modal-close-btn" @click="showContactAlertModal = false">Fechar</button>
        </div>
    </div>


    <LoadingSpinner :show="isLoadingSpinner" message="Estamos processando seu cadastro..." />
  
</template>


<script>
import apiClient from '@/services/api.js'; 
import LoadingSpinner from '@/modules/planos/LoadingSpinner.vue';

export default {
  name: 'PlanosView',
  components: { 
    LoadingSpinner
  },
  data() {
    return {      
      isProcessing: false,
      isSubmittingData: false,
      showModal: false,
      modalTitle: '',
      modalMessage: '',
      isLoadingSpinner: false,
      
      currentStep: 2, 
      selectedPlan: 'plus', 
      
      showWhatsAppChat: false,
      whatsappMessage: '',

      showPlanDetails: true, 
      lastValidatedCnpj: '',
      hasShownContactModal: false,
      showContactAlertModal: false,
      validation: {
        phoneTouched: false,
        emailTouched: false,
        phoneValid: true,
        emailValid: true
      },

      billingAddress: {
        street: '',
        number: '',
        bairro: '',
        complement: '',
        zipCode: '',
        country: 'Brasil',
        state: '',
        city: ''
      },
      fieldStates: {
        document: false,
        fullName: true,
        phone: false, // Usuário pode editar
        email: false, // Usuário pode editar
        street: true,
        zipCode: true,
        number: true,
        bairro: true,
        complement: true,
        country: true,
        state: true,
        city: true,
      },
      personalInfo: {
        fullName: '',
        document: '',
        phone: '',
        email: '' // Inicialmente vazio
      },
      requiredFields: [
        'billingAddress.street',
        'billingAddress.zipCode',
        'billingAddress.number',
        'billingAddress.state',
        'billingAddress.city',
        'personalInfo.fullName',
        'personalInfo.document',
        'personalInfo.phone',
        'personalInfo.email'
      ],
      isLoading: false,
      clienteId: null,
    }
  },

  computed: {
    // Computeds de pagamento removidos
  },

  methods: {
    closeModal() {
      this.showModal = false;
    },

    // Método para limpar espaços do email
    cleanEmailSpaces() {
      if (this.personalInfo.email) {
        this.personalInfo.email = this.personalInfo.email.replace(/\s/g, '').trim();
      }
    },

    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++
      }
    },
    
    prevStep() {      
      if (this.currentStep > 1) { 
        this.currentStep--
      }
    },

    async sendLeadToZarpon() {
      console.log('Enviando dados do lead para Zarpon...');

      const cleanPhone = this.personalInfo.phone.replace(/\D/g, '');
      const phoneWithDDI = cleanPhone.startsWith('55') ? cleanPhone : `55${cleanPhone}`;

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const startAt = `${year}-${month}-${day} ${hours}:${minutes}`;

      const zarponPayload = {
        lead: {
          name: this.personalInfo.fullName,
          phone: phoneWithDDI,
          email: this.personalInfo.email,
          variables: [
            {
              name: "idade",
              content: "30"
            },
            {
              name: "cidade",
              content: this.billingAddress.city
            }
          ]
        },
        automation_behavior: "ignore_new_keep_current",
        start_at: startAt
      };

      try {
        await apiClient.post('https://beta.zarpon.com.br/webhooks/start/wZtOuIb7PaFKPBJyG3Sy3w.aE50YlhlV1ZqM29mdE1KTA.8T3sOHSqeXO7JxTjN495KrOEFqsZ63q37O7TkPTVk5M', zarponPayload);
        console.log('✅ Dados do lead enviados para Zarpon com sucesso.');
      } catch (error) {
        console.error('Erro ao enviar dados para Zarpon:', error);
      }
    },
    
    async finalizeRegistration() {
      this.validatePhoneField();
      this.validateEmailField();

      if (!this.validation.phoneValid || !this.validation.emailValid || !this.personalInfo.fullName || !this.personalInfo.document) {
        this.modalTitle = 'Dados Incompletos';
        this.modalMessage = 'Por favor, preencha corretamente Telefone, E-mail e CNPJ.';
        this.showModal = true;
        return;
      }

      this.isProcessing = true;
      this.isLoadingSpinner = true; 

      // Aplica a limpeza de espaços no email antes da validação
      this.cleanEmailSpaces();

      if (!this.personalInfo.fullName || !this.personalInfo.document || !this.personalInfo.email || !this.personalInfo.phone) {
        this.modalTitle = 'Campos incompletos';
        this.modalMessage = 'Por favor, revise os dados cadastrais, principalmente Telefone e E-Mail antes de finalizar o cadastro.';
        this.showModal = true;
        this.isProcessing = false;
        this.isLoadingSpinner = false; 
        return;
      }
      
      try {
        await this.createCustomerIfNeeded();

        if (!this.clienteId) {
            throw new Error('Não foi possível obter o ID do cliente para continuar o cadastro.');
        }

        await this.registerInCognito();
        await this.sendLeadToZarpon(); 

        this.modalTitle = "Cadastro Realizado!";
        this.modalMessage = "Sua conta foi criada com sucesso. Verifique seu e-mail para mais informações.";
        this.nextStep(); 
        this.isLoadingSpinner = false;

      } catch (error) {
        this.modalTitle = "Alerta de Cadastro";
        this.modalMessage = error.message || "Não foi possível completar o cadastro. Tente novamente mais tarde.";
        this.showModal = true;
        this.isLoadingSpinner = false; 
      } finally {
        this.isProcessing = false;
      }
    },

    async registerInCognito() {
      console.log('Iniciando cadastro de DEGUSTAÇÃO para o e-mail:', this.personalInfo.email);
      
      try {
        const degustacaoPayload = {
          email: this.personalInfo.email,
          fullName: this.personalInfo.fullName,
          document: this.personalInfo.document.replace(/\D/g, ''),
          phone: this.personalInfo.phone.replace(/\D/g, ''),
          selectedPlan: this.selectedPlan,
          asaasCodigo: "GRATUITO7DIAS",
          asaasCodCliente: "01234567890",
          asaasCodAssinatura: "01234567890",
          billingType: "PLANO GRATUITO 7 DIAS"
        };

        await apiClient.post('/cadastrar-degustacao', degustacaoPayload);
        console.log('✅ Solicitação de cadastro de degustação enviada com sucesso.');

      } catch (error) {
        console.error('Erro ao solicitar cadastro do usuário de degustação:', error);
        const errorMessage = error.response?.data?.details || error.response?.data?.error || 'Ocorreu um erro ao criar seu usuário de acesso. Por favor, tente novamente.';
        throw new Error(errorMessage);
      }
    },

    async handleCnpjNavigation() {
      await this.fetchAndPopulateCustomerData();
      this.$nextTick(() => {
        if (this.$refs.phoneInput) {
          this.$refs.phoneInput.focus();
        }
      });
    },

    toggleWhatsAppChat() {
      this.showWhatsAppChat = !this.showWhatsAppChat
    },
    
    sendWhatsAppMessage() {
      if (this.whatsappMessage.trim()) {
        const phoneNumber = '5585992282002'
        const encodedMessage = encodeURIComponent(this.whatsappMessage)
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
        
        window.open(whatsappUrl, '_blank')
        this.whatsappMessage = ''
        this.showWhatsAppChat = false
      }
    },
    
    async consultarCNPJ() {
      const cnpj = this.personalInfo.document.replace(/\D/g, '');
      if (cnpj.length !== 14) {
        throw new Error('CNPJ inválido - deve ter 14 dígitos');
      }

      try {
        const url = `https://publica.cnpj.ws/cnpj/${cnpj}`;
        const response = await fetch(url);
        
        if (!response.ok) {
            throw new Error('Erro na resposta da API pública. Status: ' + response.status);
        }

        const data = await response.json();
        if (!data.estabelecimento || !data.razao_social) {
          throw new Error('CNPJ não encontrado ou dados da API pública incompletos');
        }

        const situacao = data.estabelecimento.situacao_cadastral;
        if (situacao !== "Ativa") {
          throw new Error(`A empresa está com a situação cadastral "${situacao}". Não é possível continuar.`);
        }

        // MODIFICAÇÃO PRINCIPAL: Não preencher telefone e email automaticamente
        this.personalInfo.fullName = data.razao_social;
        this.billingAddress.street = `${data.estabelecimento.tipo_logradouro || ''} ${data.estabelecimento.logradouro || ''}`.trim();
        this.billingAddress.number = data.estabelecimento.numero || '';
        this.billingAddress.bairro = data.estabelecimento.bairro || '';
        this.billingAddress.complement = data.estabelecimento.complemento || '';
        this.billingAddress.zipCode = data.estabelecimento.cep || '';
        this.billingAddress.city = data.estabelecimento.cidade?.nome || '';
        this.billingAddress.state = data.estabelecimento.estado?.sigla || '';
        
        // TELEFONE E EMAIL NÃO SÃO MAIS PREENCHIDOS AUTOMATICAMENTE
        // Mantemos os valores que o usuário já digitou ou deixamos em branco
        // this.personalInfo.phone = ''; // Não preencher
        // this.personalInfo.email = ''; // Não preencher

      } catch (error) {
        console.error('Erro dentro de consultarCNPJ:', error);
        throw error;
      }
    },
    
    isValidDocument(document) {
      if (!document) return false
      const cleanDoc = document.replace(/\D/g, '')
      return cleanDoc.length === 11 || cleanDoc.length === 14
    },

    onCnpjInput(e) {
      let val = e.target.value.replace(/\D/g, "");
      if (val.length > 14) val = val.slice(0, 14);
      val = val.replace(/^(\d{2})(\d)/, "$1.$2");
      val = val.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      val = val.replace(/\.(\d{3})(\d)/, ".$1/$2");
      val = val.replace(/(\d{4})(\d)/, "$1-$2");
      this.personalInfo.document = val;
    },

    onPhoneInput(e) {
      let val = e.target.value.replace(/\D/g, "");
      if (val.length > 11) val = val.slice(0, 11);
      if (val.length > 2 && val.length <= 6) {
        val = `(${val.slice(0, 2)}) ${val.slice(2)}`;
      } else if (val.length > 6) {
        val = `(${val.slice(0, 2)}) ${val.slice(2, 3)} ${val.slice(3, 7)}-${val.slice(7)}`;
      } else if (val.length > 0) {
        val = `(${val}`;
      }
      this.personalInfo.phone = val;
    },

    checkEmailPattern() {
      const email = this.personalInfo.email.toLowerCase();
      if ((email.endsWith("@gmail.com") || email.endsWith(".br")) && !this.hasShownContactModal) {
        this.triggerContactModal();
      }
    },

    triggerContactModal() {
      if (this.personalInfo.email && this.personalInfo.phone && !this.hasShownContactModal) {
        this.showContactAlertModal = true;
        this.hasShownContactModal = true;
      }
    },

    validatePhoneField() {
      this.validation.phoneTouched = true;
      this.validation.phoneValid = !!this.personalInfo.phone;
    },

    validateEmailField() {
      this.validation.emailTouched = true;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.validation.emailValid = emailRegex.test(this.personalInfo.email) && !!this.personalInfo.email;
    },
    
    async fetchAndPopulateCustomerData() {
      const doc = this.personalInfo.document.replace(/\D/g, '');
      
      if (this.isSubmittingData || (doc === this.lastValidatedCnpj && doc !== '')) return;

      if (doc.length > 0 && doc.length !== 14) {
        this.modalTitle = "Erro";
        this.modalMessage = "CNPJ errado, tente novamente.";
        this.showModal = true;
        return;
      }

      this.isSubmittingData = true;
      this.isLoadingSpinner = true;

      try {
        await this.consultarCNPJ();
        this.lastValidatedCnpj = doc;
      } catch (error) {
        this.lastValidatedCnpj = '';
        this.modalTitle = "CNPJ Inválido";
        this.modalMessage = "Não foi possível localizar o CNPJ.";
        this.showModal = true;
      } finally {
        this.isLoadingSpinner = false;
        this.isSubmittingData = false;
      }
    },

    async createCustomerIfNeeded() {
      if (this.clienteId) {
        console.log('Cliente já processado nesta sessão. ID:', this.clienteId);
        return;
      }
      
      this.isProcessing = true;

      if (!this.personalInfo.fullName || !this.personalInfo.document) {
          this.isProcessing = false;
          throw new Error("Dados do cliente incompletos para cadastro.");
      }

      const cleanDoc = this.personalInfo.document.replace(/\D/g, '');

      try {
        const consultaResponse = await apiClient.get(`/consultar-cliente/${cleanDoc}`);
        
        if (consultaResponse.data && consultaResponse.data.totalCount > 0 && Array.isArray(consultaResponse.data.data) && consultaResponse.data.data.length > 0) {
          const clienteEncontrado = consultaResponse.data.data[0];
          this.clienteId = clienteEncontrado.id;
          this.isProcessing = false;
          console.log(`✅ Cliente existente encontrado. ID: ${this.clienteId}. Cadastro de novo cliente ignorado.`);
          return; 
        }
      } catch (error) {
        if (error.response && error.response.status !== 404) {
          console.error('Erro inesperado ao consultar cliente:', error);
          this.isProcessing = false;
          throw new Error("Falha na API de consulta de cliente.");
        }
      }

      try {
        const newCustomerData = {
            name: this.personalInfo.fullName,
            cpfCnpj: cleanDoc,
            email: this.personalInfo.email,
            mobilePhone: this.personalInfo.phone.replace(/\D/g, ''),
            address: this.billingAddress.street,
            addressNumber: this.billingAddress.number,
            bairro: this.billingAddress.bairro,
            complement: this.billingAddress.complement,
            postalCode: this.billingAddress.zipCode.replace(/\D/g, ''),
            notificationDisabled: false,
            observations: "Cadastrado via Jornada de Degustação", 
            groupName: "PLANO PLUS"
        };
        
        const cadastroResponse = await apiClient.post('/cadastrar-cliente', newCustomerData);
        this.clienteId = cadastroResponse.data.id;
        console.log('✅ Novo cliente cadastrado com sucesso! ID:', this.clienteId);
        
      } catch (error) {
        console.error('Erro ao cadastrar novo cliente:', error);
        throw error;
      } finally {
          this.isProcessing = false;
      }
    }
  },

  mounted() {
    // Lógicas de montagem não são mais necessárias para o fluxo principal
  },

  watch: {
    // Watchers de pagamento foram removidos
  }
}
</script>


<style scoped>

.boleto-container {
  max-width: 900px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  background-color: white;
  color: black;
}


.step-3 {
  display: flex;
  flex-direction: column;   /* Deixa os elementos em coluna */
  /* justify-content: center;  /* Centraliza verticalmente */
  align-items: center;      /* Centraliza horizontalmente */
  text-align: center;       /* Centraliza o texto */
  min-height: 100vh;        /* Ocupa a altura inteira da tela */
  gap: 10px;                /* Espaço entre os elementos */
}

.linha-digitavel {
  border: 2px solid black;
  padding: 8px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
}

.boleto-box {
  border: 2px solid black;
}

.linha {
  display: flex;
  border-bottom: 1px solid black;
}

.linha:last-child {
  border-bottom: none;
}

.col {
  border-right: 1px solid black;
  padding: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.col:last-child {
  border-right: none;
}

.col.grande {
  flex: 3;
}

.col.pequeno {
  flex: 1.2;
}

.col.logo {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.numero {
  flex: 0.5;
  font-weight: bold;
  font-size: 18px;
  align-items: center;
}

.col.linha-digitavel-right {
  flex: 2;
  font-weight: bold;
  font-size: 14px;
  align-items: center;
}

.col.qrcode {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.codigo-barras {
  flex: 3;
  justify-content: center;
  align-items: center;
}

.codigo-barras-texto {
  font-family: 'Libre Barcode 128', monospace;
  font-size: 40px;
}

.rotulo {
  font-size: 10px;
  color: gray;
}

a {
  color: blue;
  text-decoration: underline;
  font-size: 10px;
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 450px;
  text-align: center;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: #333;
}

.modal-message {
  margin-bottom: 25px;
  font-size: 1rem;
  color: #555;
  white-space: pre-wrap; /* Para quebras de linha em mensagens de erro */
}

.modal-close-btn {
  background-color: #3E8DDD;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.2s;
}

.modal-close-btn:hover {
  background-color: #3477bb;
}

/* NOVO: Estilo para botão desabilitado */
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}



@media print {
  body {
    visibility: hidden;
  }

  .boleto-container {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

@keyframes toast-fadein {
  from { opacity: 0; transform: translate(-50%, -100%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}

@keyframes toast-fadeout {
  from { opacity: 1; transform: translate(-50%, -50%); }
  to { opacity: 0; transform: translate(-50%, -100%); }
}

/* Adicione ao seu arquivo CSS */
.form-input-size-4 {
  flex: 0 0 calc(33.333% - 10px) !important;
  max-width: calc(33.333% - 10px) !important;
}

.form-input-size-8 {
  flex: 0 0 calc(66.666% - 10px) !important;
  max-width: calc(66.666% - 10px) !important;
}

.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.unlock-btn {
  margin-top: 15px;
  padding: 8px 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.unlock-btn:hover {
  background-color: #e9ecef;
}

.icone-svg {
 flex-shrink: 0; /* evita encolher */
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.narrow-wizard {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.narrow-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.narrow-title {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
  text-align: center;
}

.wizard {
  display: flex;
  justify-content: space-between;
}

.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.step-info {
  max-width: 200px;
}

.planos-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  position: relative;
  min-height: 100vh;
  padding-bottom: 60px;
  background-color: #fff; 
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  max-width: 350px;
  height: auto;
}

.wizard {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;
}

.wizard::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #e0e0e0;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.step.active .step-number {
  background-color: #E4A64E;
}

.step-info {
  text-align: center;
  padding: 0 10px;
}

.step-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.step-description {
  font-size: 0.9em;
  color: #666;
}

.step-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.step-content h2 {
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
}

.plans-container {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.plan-card {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 600px;
}

.plan-card2 {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.plan-card:hover {
  transform: translateY(-5px);
}

.plan-card.plus {
  border-top: 4px solid #E4A64E;
}

.plan-header {
  background-color: #E4A64E;
  color: white;
  padding: 20px;
  text-align: center;
}

.plan-sub {
  background-color: #ffffff;
  color: #000000;
  padding: 10px;
}

.plan-header h2 {
  margin: 0;
  color: #ffffff;
}

.plan-pricing {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.monthly, .yearly {
  margin-bottom: 15px;
}

.price {
  font-size: 1.8em;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  line-height: 1;
}

.price::before {
  content: "R$";
  font-size: 0.6em;
  align-self: flex-start;
  margin-right: 4px;
  margin-top: 0.2em;
}

.period {
  color: #666;
  font-size: 0.9em;
}

.savings {
  background-color: #d9d8d6;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #000000;
  font-size: 0.9em;
}

.savings2 {
  background-color: #53b42f;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 0.9em;
}

.plan-features {
  padding: 20px;
  flex-grow: 1;
  gap: 12px; 
}

.feature {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.feature i {
  color: #E4A64E;
  margin-right: 10px;
  font-size: 1.2em;
  vertical-align: middle;
}

.feature .menu-icon {
  color: #E4A64E;
  margin-right: 10px;
  width: 1.2em;
  height: 1.2em;
  stroke-width: 1.5;
}

.feature input[type="checkbox"] {
  margin-right: 10px;
}

.select-button {
  display: block;
  width: 100%;
  padding: 15px;
  background-color: #E4A64E;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.select-button:hover {
  background-color: #E4A64E;
}

.navigation-buttons {
  display: flex;
  width: 100%;
  gap: 10px; 
  justify-content: space-between;
  margin-top: 30px;
}

.back-button, .next-button {
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
}

.back-button {
  padding: 15px;
  background-color: #f1f1f1;
  color: #333;
}

.nav-button {
  flex: 1; /* Isso fará com que cada botão ocupe igual espaço */
  min-width: 0; /* Importante para evitar problemas de overflow */
  padding: 2px; /* Ajuste o padding conforme necessário */
  text-align: center;
}

.next-button {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o botão de voltar no topo */
.back-button-top {
  position: absolute;
  top: 20px;
  right: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #E4A64E;
  text-decoration: none;
  font-weight: bold;
  padding: 8px 12px;
  border: 1px solid #E4A64E;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.back-link:hover {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o footer */
.site-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  text-align: left;
  color: #666;
  font-size: 0.9em;
  border-top: 1px solid #e0e0e0;
}

/* Estilos para o botão do WhatsApp */
.whatsapp-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.whatsapp-button i {
  color: white;
  font-size: 30px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Estilos para o chat do WhatsApp */
.whatsapp-chat {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 300px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  overflow: hidden;
}

.chat-header {
  background-color: #075E54;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-chat {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
}

.chat-body {
  padding: 15px;
}

.chat-body textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  resize: none;
}

.chat-footer {
  padding: 10px 15px;
  text-align: right;
  background-color: #f5f5f5;
}

.send-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
} 

.send-button:hover {
  background-color: #128C7E;
}

.plan-name {
  background-color: #E4A64E;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 15px;
}

.collapse-item {
  border-bottom: 1px solid #eee;
  padding: 15px 0;
}

.collapse-item:last-child {
  border-bottom: none;
}

.collapse-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
}

.collapse-icon {
  margin-left: 10px;
  transition: transform 0.3s;
}

.collapse-icon.expanded {
  transform: rotate(180deg);
}

.collapse-content {
  margin-top: 15px;
  padding-left: 20px;
}


.form-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: left;
  width: 100%;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.form-group {
  flex: 1 1 100%;
  min-width: 0;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

.required {
  color: #dc3545;
}

.form-input, .form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 38px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #E4A64E;
  box-shadow: 0 0 0 2px rgba(228, 166, 78, 0.1);
}

/* Estilos para desktop */
@media (min-width: 768px) {
  .form-row {
    flex-wrap: nowrap;
  }
  
  /* Campos que devem ocupar 1/3 da linha */
  .form-group.size-4 {
    flex: 0 0 calc(33.333% - 10px);
  }
  
  /* Campos que devem ocupar 2/3 da linha */
  .form-group.size-8 {
    flex: 0 0 calc(66.666% - 10px);
  }
  
  /* Campos de endereço em 3 colunas */
  .address-row .form-group {
    flex: 0 0 calc(33.333% - 10px);
  }
}

/* Estilo para campos desabilitados */
.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.coupon-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FF6B00; /* Laranja */
  color: white;
  padding: 15px 30px;
  border-radius: 25px; /* Cantos arredondados */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  text-align: center;
  opacity: 0;
  transition: all 0.3s ease;
  max-width: 80%;
}

.coupon-toast.show {
  opacity: 1;
  animation: slideIn 0.3s ease-out;
}

.coupon-toast.hide {
  opacity: 0;
  animation: slideOut 0.3s ease-in;
}

@keyframes slideIn {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
}

.payment-methods {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.payment-method {
  flex: 1;
  padding: 8px;
  border: 2px solid #ddd;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-method.active {
  border-color: #E4A64E;
  background-color: #E4A64E;
  color: white;
}

.payment-method:hover {
  border-color: #E4A64E;
}

.coupon-input {
  display: flex;
  gap: 10px;
  align-items: end;
}

.coupon-input .form-group {
  flex: 1;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #E4A64E;
  color: white;
}

.btn-primary:hover {
  background-color: #d6963e;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #E4A64E;
  color: #E4A64E;
}

.btn-outline:hover {
  background-color: #E4A64E;
  color: white;
}

.finalize-btn {
  width: 100%;
  padding: 15px;
  font-size: 16px;
  margin-top: 20px;
}

.boleto-display, .pix-display {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-top: 20px;
  text-align: center;
}

.boleto-header {
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.boleto-info {
  text-align: left;
  margin: 20px 0;
}

.boleto-barcode {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  letter-spacing: 1px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 20px 0;
}

.qr-code {
  margin: 20px 0;
}

.pix-code {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  word-break: break-all;
  margin: 20px 0;
}

.copy-btn {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .form-row, .payment-methods {
    flex-direction: column;
  }
  
  .payment-method {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .wizard {
    display: flex;
    flex-wrap: nowrap; /* Impede que os itens quebrem para nova linha */
    overflow-x: auto; /* Permite rolagem horizontal se necessário */
    gap: 5px; /* Espaço entre os steps */
    padding-bottom: 10px; 
  }

  .wizard::before {
    display: none;
  }

  .step {
    flex: 0 0 auto; /* Não permite que os itens cresçam ou encolham */
    width: 30%; /* Largura aproximada para 3 itens */
    min-width: 120px; /* Largura mínima para cada step */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
  }

  .step-number {
    width: 30px;
    height: 30px;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .step-info {
    text-align: center;
    padding: 0;

  }

  .step-title {
    font-size: 12px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  
  .step-description {
    font-size: 10px;
    display: none; 
  }

  .wizard::-webkit-scrollbar {
    display: none;
  }
  
  .wizard {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .plans-container {
    flex-direction: column;
  }

  .plan-card {
    max-width: 100%;
  }

  .whatsapp-chat {
    width: 280px;
    right: 10px;
  }
  
  .whatsapp-button {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }
  
  .whatsapp-button i {
    font-size: 25px;
  }

  .back-button-top {
    position: static;
    text-align: right;
    margin-bottom: 15px;
    padding-right: 15px;
  }

  /* Estilo padrão (mobile-first) - campos em 100% */
.form-group-responsive {
  width: 100%;
}

/* Em desktop - campos com proporções 8 e 4 */
@media (min-width: 768px) {
  .form-group-size-4 {
    flex: 0 0 calc(33.333% - 10px) !important;
    max-width: calc(33.333% - 10px) !important;
  }

  .form-group-size-8 {
    flex: 0 0 calc(66.666% - 10px) !important;
    max-width: calc(66.666% - 10px) !important;
  }
}

}
</style>
